import createDuck from '../../lib/ducks/remoteDuck'
import Wishlist from '../../lib/api/wishlist'

export default createDuck({
  namespace: 'account',
  store: 'wishlist',
  fetchCallback: (option) => Wishlist.get(option),
})
